module.exports = __webpack_public_path__ + "img/facebook.9daece0f.svg";